import { render } from "./Dropdown1.vue?vue&type=template&id=2db6fbef"
import script from "./Dropdown1.vue?vue&type=script&lang=ts"
export * from "./Dropdown1.vue?vue&type=script&lang=ts"
script.render = render

export default script